import { addParamsToUrl } from 'utils';

import { URL } from '../constants';
import { apiLoaderInstance } from '../instance';

import { CourseSubmissionPdfRequest } from './types';

export const downloadPdf = () => {
  const origin = typeof window !== 'undefined' ? window.location.origin : '';

  return apiLoaderInstance.get(`${origin}/pdfs/decision-tool.pdf`, {
    responseType: 'blob',
  });
};

export const downloadCourseSubmissionPdf = ({
  id,
  timezone,
}: CourseSubmissionPdfRequest) =>
  apiLoaderInstance.get(
    addParamsToUrl(URL.COURSE_SUBMISSIONS_CERTIFICATE_PDF.replace(':id', id), {
      timezone,
    }),
    { responseType: 'blob' }
  );
